<template>
  <div class="user_box">
    <div style="display: flex;align-items: center;justify-content: space-between;">
      <span class="user_name">{{userInfo?.nickname || '请登录'}}</span>
      <img class="user_logout" src="@/assets/images/log-out.png" @click="logout">
    </div>
    <div class="user_money">
      <img src="@/assets/images/point-active.png">{{userInfo.beans}}
    </div>
  </div>
</template>
<script>
export default {
  name: "SidebarUser",
  data () {
   return {}
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  methods:{
    async logout() {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await this.$store.dispatch('USER_LOGOUT')
        // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        this.$router.push(`/login`)
      })
      
    }
  }
}
</script>
<style lang="scss" scoped>
.user_box {
  // height: 70px;
  font-size: 16px;
  margin: 28px 16px;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(224, 243, 255, 1) 0%, rgba(191, 230, 242, 0.1) 100%);
  padding: 16px 13px;
  .user_name {
    display: inline-block;
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #404040;
  }
  .user_logout {
    margin-left: 8px;
    vertical-align: middle;
    cursor: pointer;
  }
  .user_money {
    width: fit-content;
    margin-top: 8px;
    border-radius: 12px;
    background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
    color: #FFFFFF;
    padding: 5px 12px;
    font-size: 12px;
    img {
      width: 16px;
      vertical-align: bottom;
      margin-right: 2px;
    }
  }
}
</style>